import type { FieldPilotAnnotationMode } from "@/features/field-pilot/label-utils";

export type FieldPilotDisplayExportSeedInput = {
  colorizeBy: "status" | "tag";
  showMeasurementValues: boolean;
  viewportAnnotation: FieldPilotAnnotationMode;
};

export type FieldPilotDisplayExportSeed = {
  colorizeBy: "status" | "tag";
  showMeasurementValues: boolean;
  labelAnnotation: FieldPilotAnnotationMode;
};

/** Display options that map 1:1 onto PDF export plan-markup settings. */
export function fieldPilotExportOptionsFromDisplay(
  display: FieldPilotDisplayExportSeedInput
): FieldPilotDisplayExportSeed {
  return {
    colorizeBy: display.colorizeBy,
    showMeasurementValues: display.showMeasurementValues,
    labelAnnotation: display.viewportAnnotation,
  };
}
